// 包含多个mutations中的方法名称的常量

export const ADD_TODO = 'add_todo';//添加
export const DELETE_TODO = 'delete_todo';//删除
export const SELECT_ALL_TODO = 'select_all_todo';//全选、取消
export const DELETE_FINISHED_TODO = 'delete_finished_todo';//清除已经完成的todo


// WEBPACK FOOTER //
// ./src/store/mutations-type.js